import React, { Fragment, useState, useRef, useEffect } from 'react';
import {Col, FormGroup, Input, Label, Media, Row} from "reactstrap";
import {
    checkTitle
} from "../../store/prodcutSlice";
import { useDispatch } from 'react-redux';
import DropZone from "../../../../share-components/upload/dropzone";
import { getInventoryProducts, updateInventoryBulk, downloadImportBySkuSample } from '../../store/inventorySlice';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 50,
        border: 'none',
    })
};

const modeOptions = [
    { id: 'increase', name: 'Increase (+ quantity)' },
    { id: 'decrease', name: 'Decrease (- quantity)' },
    { id: 'replace', name: 'Replace (= quantity)' },
];

const bulkUpload = (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ref = useRef(null);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const dispatch = useDispatch();
    const { errors, control, register,setValue,trigger,roles,getValues, isImportQuantity } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [imagePreloader, setImageLoader] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [loading, isSetLoading] = useState(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [uploadFile, setUploadFile] = useState(null);

    const onChangeFile = e => {
        setImageLoader(true);
		setUploadFile(e);
        setValue('file',e[0]);
        console.log(e);
        setImageLoader(false);
	};

    const handleModeChange = (e) => {
        setValue('mode', e ? e.id : 'replace');
        trigger('mode');
    }

    const handleDownloadSample = (e) => {
        e.preventDefault();
        dispatch(downloadImportBySkuSample()).then(res => {
            if (res.error) return;
            const url = window.URL.createObjectURL(new Blob([res.payload]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'inventory_import_sample.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    return (
        <Fragment>
            {isImportQuantity && <FormGroup>
                <Label className="form-label">Import Mode</Label>
                <Select
                    placeholder="Select Import Mode"
                    className="select2-filter"
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={modeOptions.find(option => option.id === getValues('mode')) || modeOptions[2]}
                    onChange={handleModeChange}
                    options={modeOptions}
                />
                <Typography variant="caption">
                    Increase/Decrease adjust existing stock by the file's quantity. Replace sets stock to the file's quantity exactly.
                </Typography>
            </FormGroup>}
            <FormGroup>
                <div className="product-box">
                    <div className="product-img pt-3 pb-3">
                        {imagePreloader&& <div className="loader-box">
                            <div className="loader-2"></div>
                        </div>}
                        {!imagePreloader&& <DropZone
                                        extension={isImportQuantity ? ".csv,.xlsx,.xls" : ".csv"}
                                        onChangeFile={onChangeFile}></DropZone>}
                    </div>
                    {uploadFile ? (

                        <Typography>File: {`${uploadFile[0].name}`}{' '}</Typography>

                    ) : (
                        ''
                    )}
                </div>
            </FormGroup>
            {isImportQuantity && <FormGroup>
                <a href="#" onClick={handleDownloadSample} style={{color: "black", fontWeight: "normal"}}>
                    <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Download Sample File
                </a>
            </FormGroup>}
        </Fragment>
    );
}

export default bulkUpload;
